import { Flex, Box, Text, Button } from '@chakra-ui/react';
import { constantRotation } from '@texas/resources/animations/animations';

interface Props {
  title: string;
  sub: string;
  onClick: () => void;
  isDisabled?: boolean;
  size?: 'default' | 'sm';
}

export function SelectUser({
  title,
  sub,
  onClick,
  isDisabled,
  size = 'default',
}: Props) {
  const compact = size === 'sm';

  return (
    <Button
      variant="unstyled"
      gap={2}
      sx={{
        ':hover .sub_label': {
          height: '12px',
          opacity: 1,
        },
        ':hover .sub_rot': {
          animation: constantRotation(),
        },
      }}
      display="flex"
      alignItems="center"
      w="fit-content"
      textAlign="start"
      isDisabled={isDisabled}
      onClick={onClick}
    >
      <Box
        boxSize={compact ? 7 : 10}
        border="2px dashed"
        borderColor="gray.400"
        borderRadius="full"
        className="sub_rot"
      />
      <Flex flexDir="column">
        <Text
          color="gray.400"
          fontSize={compact ? 'sm' : undefined}
          fontWeight="bold"
        >
          {title}
        </Text>
        <Text
          fontSize={compact ? 'xs' : 'sm'}
          transition="height 200ms ease, opacity 200ms ease"
          height={0}
          opacity={0}
          className="sub_label"
        >
          {sub}
        </Text>
      </Flex>
    </Button>
  );
}
